import { MemberList } from '~/components/upload/lithostrat/member/MemberList';
import { useUpdateFormationOutletContext } from '~/routes/upload/lithostrat/formation/$formationId';

export default function FormationUpdateMembersRoute() {
  const { formation } = useUpdateFormationOutletContext();
  return <MemberList formationId={formation.id} />;
}
